import { __assign } from "tslib";
/* eslint-disable camelcase */
import { getHighestQualityVideo, getFilePluginComponentData, } from '../uploadStrategy/uploadStrategy';
import { isSSR, IMAGE_TYPE, VIDEO_TYPE, FILE_UPLOAD_TYPE, } from 'wix-rich-content-common';
import { MediaManagerPanel, MediaManagerMediaType } from './mediaManagerPanel';
export default function mediaManagerStrategy(hasPlugin, appDefId) {
    var _a;
    if (isSSR())
        return {};
    var mediaManagerInstance = window.editorSDK || window.ModuleRegistry;
    if (!mediaManagerInstance)
        return {};
    var mediaManager = new MediaManagerPanel(mediaManagerInstance);
    var imageUpload = function (index, multiple, updateEntity) {
        mediaManager.open({
            mediaType: MediaManagerMediaType.IMAGE,
            appDefId: appDefId,
            isMultiSelect: multiple,
            onSuccess: function (items) {
                var imageData = items.map(function (_a) {
                    var title = _a.title, uri = _a.uri, height = _a.height, width = _a.width;
                    return ({
                        id: uri,
                        height: height,
                        width: width,
                        original_file_name: title,
                        file_name: uri,
                    });
                });
                updateEntity({
                    data: imageData,
                    index: index,
                });
            },
        });
    };
    var videoUpload = function (updateEntity) {
        mediaManager.open({
            mediaType: MediaManagerMediaType.VIDEO,
            appDefId: appDefId,
            onSuccess: function (items) {
                var _a = items[0].fileOutput, video = _a.video, image = _a.image;
                var pathname = getHighestQualityVideo(video).url;
                var _b = image[0], url = _b.url, width = _b.width, height = _b.height;
                var thumbnail = { pathname: url, width: width, height: height };
                updateEntity({ data: { pathname: pathname, thumbnail: thumbnail } });
            },
        });
    };
    var fileUpload = function (updateEntity) {
        mediaManager.open({
            mediaType: MediaManagerMediaType.ALL_MEDIA,
            appDefId: appDefId,
            onSuccess: function (items) {
                var _a = items[0], name = _a.title, mediaType = _a.mediaType, fileUrl = _a.fileUrl;
                var componentData = getFilePluginComponentData(name, mediaType, fileUrl);
                updateEntity({ data: [componentData] });
            },
        });
    };
    return {
        helpers: __assign({}, (hasPlugin(IMAGE_TYPE) && { handleFileSelection: imageUpload })),
        config: (_a = {},
            _a[VIDEO_TYPE] = __assign({}, (hasPlugin(VIDEO_TYPE) && {
                handleFileSelection: videoUpload,
            })),
            _a[FILE_UPLOAD_TYPE] = __assign({}, (hasPlugin(FILE_UPLOAD_TYPE) && {
                handleFileSelection: fileUpload,
            })),
            _a),
    };
}
//# sourceMappingURL=mediaManagerStrategy.js.map